class FixedNavigationProduct extends HTMLElement {
  constructor() { 
    super();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.quantitySelector = document.querySelector('.quantity_selector_with_form');
    this.fixedNav = this;
    this.isVisible = false;
    this.lastScrollTop = 0;
    
    // Add padding to body when component is present
    document.body.classList.add('quick-order-padding');
    
    // Measure and calculate padding
    const calculatePadding = () => {
      // Get quick-order-padding height
      const quickOrderHeight = this.offsetHeight;
      
      // Get last shopify-section padding
      const shopifySections = document.querySelectorAll('.shopify-section');
      const lastSection = shopifySections[shopifySections.length - 1];
      
      // Set padding directly using JavaScript
      if (lastSection) {
        // Set padding equal to quick-order height
        lastSection.style.paddingBottom = `${quickOrderHeight}px`;
      }
    };
    
    // Initial calculation
    calculatePadding();
    
    // Re-calculate on resize
    window.addEventListener('resize', calculatePadding);
    
    if (this.quantitySelector) {
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }
  }

  handleScroll() {
    if (!this.quantitySelector) {
      return;
    }

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = currentScrollTop > this.lastScrollTop;
    const quantitySelectorRect = this.quantitySelector.getBoundingClientRect();
    const scrolledPastSelector = quantitySelectorRect.top < 0;
    const shouldShow = scrolledPastSelector && (
      (scrollingDown && quantitySelectorRect.top < 0) ||
      (!scrollingDown && quantitySelectorRect.top < 0)
    );

    if (shouldShow !== this.isVisible) {
      this.isVisible = shouldShow;
      if (shouldShow) {
        this.style.removeProperty('display');
        requestAnimationFrame(() => {
          this.classList.add('is-visible');
        });
      } else {
        this.classList.remove('is-visible');
        setTimeout(() => {
          if (!this.isVisible) {
            this.style.display = 'none';
          }
        }, 300);
      }
    }
    
    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }
}

if (!customElements.get('quick-order-list')) {
  customElements.define('quick-order-list', FixedNavigationProduct);
}
